import { isEmpty } from 'ramda'
import { buildImgSrc } from '@/helpers/image-url'
import { LazyImage } from '@/scopes/common/components/Image'
import { useAccommodationContext } from '@/scopes/prices/components/AccommodationContext'
import { PriceBreakdown } from '@/scopes/prices/components/PriceBasket/PriceBreakdown'
import { TripSummary } from '@/scopes/prices/components/PriceBasket/TripSummary'
import { getTransportSelector, transportResponseSelector } from '@/scopes/prices/components/selectors'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import styles from './PriceBasket.module.css'

export function PriceBasket() {
  const { image, name } = useAccommodationContext()
  const { tripSummary } = usePricesSelector(transportResponseSelector)
  const { loading } = usePricesSelector(getTransportSelector)

  if (loading || isEmpty(tripSummary))
    return null

  return (
    <div className={styles.wrapper}>
      <div className={styles.column}>
        <LazyImage
          src={buildImgSrc(image, 640) ?? ''}
          alt={name}
        />
        <TripSummary />
      </div>
      <div className={styles.column}>
        <PriceBreakdown />
      </div>
    </div>
  )
}
